import {useDebugValue, useEffect} from 'react';

import {useInitialization} from '../../../hooks/useInitialization';

import {getObjectValues} from '../../../utils/object';

function useFormActions(data) {
    const {
        formEvents: {
            onSettingsChange
        },
        initialFormSettings,
        changeFormSettings
    } = data;

    function setSettings(nextSettings) {
        changeFormSettings(nextSettings);

        onSettingsChange(nextSettings);
    }

    function setSettingsInitial() {
        setSettings(initialFormSettings);
    }

    function setHasLoaded(hasLoaded) {
        setSettings({
            hasLoaded
        });
    }

    function setIsSubmitting(isSubmitting) {
        setSettings({
            isSubmitting
        });
    }

    function setHasSubmitted(hasSubmitted) {
        setSettings({
            hasSubmitted
        });
    }

    function setHasSubmittedSuccessfully(hasSubmittedSuccessfully) {
        setSettings({
            hasSubmittedSuccessfully
        });
    }

    function setWasLastSubmittedSuccessfully(wasLastSubmittedSuccessfully) {
        setSettings({
            wasLastSubmittedSuccessfully
        });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(setSettingsInitial, [...getObjectValues(initialFormSettings)]);

    useInitialization(function initializeSettings() {
        setHasLoaded(true);
    });

    const result = {
        setIsSubmitting,
        setHasSubmitted,
        setHasSubmittedSuccessfully,
        setWasLastSubmittedSuccessfully
    };

    useDebugValue(result);

    return result;
}

export {useFormActions};
